module.exports = __webpack_public_path__ + "static/media/bg.56e0f4d3.png";